var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlotsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.008 2c1.664.002 3.343.702 4.436 1.707C21.628 4.794 22.006 6.104 22 7.993l-.006.103a.923.923 0 01-1.031.811c-1.925-.236-2.818-.727-3.297-1.218-.638-.568-1.282-1.616-1.543-3.634-.029.035-.06.07-.089.108A8.948 8.948 0 0014.92 5.94c-.631 1.34-1.126 3.285-.803 6.063a4.999 4.999 0 11-3.991 8.156A4.488 4.488 0 016.5 22a4.5 4.5 0 110-9l.074.002c.623-2.928 1.711-5.216 3.299-7.01C11.466 4.19 13.522 2.93 16 2l.007-.002V2zM13.91 4.63c-1.129.658-2.097 1.431-2.914 2.354-1.376 1.556-2.364 3.58-2.945 6.292a4.5 4.5 0 011.688 1.105 5.01 5.01 0 012.89-2.19c-.358-3.055.178-5.286.934-6.89.112-.239.229-.462.347-.671zm3.688-.861c.186 1.548.603 2.287.908 2.64l.158.16.04.035.035.038c.125.127.517.45 1.74.674-.078-1.222-.403-1.91-1.05-2.504-.477-.44-1.123-.81-1.831-1.043z",
    fill: "currentColor"
  })));
}
SvgSlotsFilled.displayName = 'SlotsFilled';
export default SvgSlotsFilled;